import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'

@Injectable()
export class PlatformJsonService {
  constructor(private http: HttpClient) {
  }

    platforms: any[] = [
        {
            "platformId": "765e8f9a-0574-48a1-894d-026d57c96929",
            "storeScaffoldId": "2755d1fb-7f2f-4f1d-9d04-8368624db0ba",
            "logo":"../../../assets/img/plataformas/logo-nuvemshop.png",
            "name":"Nuvemshop",
            "seoName": "nuvemshop-flower",
            "integrada": true,
            "video": "",
            "image": "",
            "order":1,
            "platformJavascript":"polen-nuvemshop-pollinator",
            "domain": ".lojavirtualnuvem.com.br",
            "hasApp": true,
            "linkToPlatform": "https://www.nuvemshop.com.br/loja-aplicativos-nuvem/polen"
            
        }, 
        {
            "platformId": "f7dea8ff-04b0-49fd-96aa-3395f09f22b4",
            "storeScaffoldId": "55f2ee12-8979-46c9-87b0-8ed52b86db84",
            "logo":"../../../assets/img/plataformas/logo-tray.png",
            "name":"Tray",
            "seoName":"tray-pollinator",
            "integrada": true,
            "video": "https://www.youtube.com/embed/WDs1HClT9Co" ,
            "image": "",
            "order":2,
            "platformJavascript":"polen-tray-pollinator",
            "domain": "",
            "hasApp": true,
            "linkToPlatform": "https://clientes.tray.com.br/"
        },
        {
            "platformId": "032e9408-d508-4398-a32d-56d1d0884b08",
            "storeScaffoldId": "e365a5f9-46fb-4c72-943f-931a3233d4d3",
            "logo":"../../../assets/img/plataformas/logo-shopify.png",
            "name":"Shopify",
            "seoName": "shopify",
            "integrada": true,
            "video": "",
            "image": "https://storage.googleapis.com/sealpolen-files.polinizador.com.br/painel/shopify-aplicativos.png" ,
            "order":3,
            "platformJavascript":"polen-shopify-pollinator",
            "domain": ".myshopify.com",
            "hasApp": true,
            "linkToPlatform": "https://apps.shopify.com/o-polen"
        },
        {
            "platformId": "5ea6e0e0-c430-4aaa-92bc-a7739395cb26",
            "storeScaffoldId": "76549b6a-3134-4f0b-b850-d65b1a6a77e2",
            "logo":"../../../assets/img/plataformas/logo-cartpanda.png",
            "name":"CartPanda",
            "seoName": "cartx",
            "integrada": true,
            "video": "https://www.youtube.com/embed/RHc_CZWugBU",
            "image": "",
            "order":4,
            "platformJavascript":"polen-cartx-pollinator",
            "domain": ".oncartx.io",
            "hasApp": true,
            "linkToPlatform": "https://accounts.cartx.io/login"
        },
        {
            "platformId": "1d4d6a04-fa02-4aa5-a285-ff580d9470d0",
            "storeScaffoldId": "fa8b2a14-f711-4014-a978-31f91478b6ec",
            "logo":"../../../assets/img/plataformas/logo-woccommerce.png",
            "name":"Woccomerce",
            "seoName": "woocommerce-flower",
            "integrada": true,
            "video": "",
            "image": "",
            "order":5,
            "platformJavascript": "polen-woocommerce-pollinator",
            "domain": "",
            "hasApp": false,
            "linkToPlatform": ""
        },
        {
            "platformId": "a89190b6-ac68-4180-b60c-8848c67de643",
            "storeScaffoldId": "cab70325-682e-49cb-8631-6c6b5f9e3de0",
            "logo":"../../../assets/img/plataformas/logo-loja-integrada.png",
            "name":"Loja Integrada",
            "seoName":"loja-integrada-flower",
            "integrada": true,
            "video": "",
            "image": "",
            "order":6,
            "platformJavascript": "polen-lojaintegrada-pollinator",
            "domain": "",
            "hasApp": false,
            "linkToPlatform": ""
        },
        {
            "platformId": "4b9c0754-2c8b-4e17-b09b-dd4a24f46035",
            "storeScaffoldId": "a1d7d12e-bc16-410e-b2c8-364265f3a626",
            "logo":"../../../assets/img/plataformas/logo-tray-corp.png",
            "name": "Tray Corp - Fbits",
            "seoName": "traycorp",
            "integrada": true,
            "video": "",
            "image": "",
            "order":7,
            "platformJavascript": "polen-traycorp-pollinator",
            "domain": "",
            "hasApp": false,
            "linkToPlatform": ""
        },
        {
            "platformId": "d086d659-b5f3-459e-9a2c-a09d4d2ed837",
            "storeScaffoldId": "58ba5b58-9e7d-4ad0-883c-100aba32a766",
            "logo":"../../../assets/img/plataformas/logo-dooca.png",
            "name": "Dooca",
            "seoName": "dooca",
            "integrada": true,
            "video": "",
            "image": "",
            "order":8,
            "platformJavascript": "polen-dooca-pollinator",
            "domain": "",
            "hasApp": false,
            "linkToPlatform": ""
        },
        {
            "platformId": "c5ef108f-e02d-4d57-bd38-e67d800aea2a",
            "storeScaffoldId": "2d0c261e-e6a8-4d91-8ab1-69dd1628155b",
            "logo":"../../../assets/img/plataformas/logo-vtex.png",
            "name": "VTEX",
            "seoName": "vtex-flower",
            "integrada": true,
            "video": "",
            "image": "",
            "order":9,
            "platformJavascript": "polen-vtex-pollinator",
            "domain": "",
            "hasApp": false,
            "linkToPlatform": ""
        },
        {
            "platformId": "0dc5252e-5d4f-4ed1-9a02-8e3d237dd30c",
            "storeScaffoldId": "db86b17c-b8a7-4899-8fcf-792bc6232abc",
            "logo":"../../../assets/img/plataformas/logo-oracle.png",
            "name": "Oracle ATG",
            "seoName": "oracle-atg",
            "integrada": true,
            "video": "",
            "image": "",
            "order": 10,
            "platformJavascript": "polen-oracle-atg-pollinator",
            "domain": "",
            "hasApp": false,
            "linkToPlatform": ""
        },
        {
            "platformId": "11bc8d16-361b-4510-b931-5f3b7eacdd60",
            "storeScaffoldId": "bd75764c-3e0b-4336-99ab-ef97620639e3",
            "logo":"../../../assets/img/plataformas/logo-wbuy.png",
            "name": "wBuy",
            "seoName": "wbuy",
            "integrada": true,
            "video": "https://www.youtube.com/embed/7cM5z1IzTWA",
            "image": "",
            "order": 11,
            "platformJavascript": "polen-wbuy-pollinator",
            "domain": "",
            "hasApp": true,
            "linkToPlatform": "https://sistema.sistemawbuy.com.br/painel/login"
        },
        {
            "platformId":"c924b400-e202-42e9-8cc5-e75f94d278dc",
            "storeScaffoldId": "21c5c720-f7a3-4af5-a80c-97c177708326",
            "logo":"../../../assets/img/plataformas/logo-irroba.png",
            "name": "Irroba",
            "seoName": "irroba",
            "integrada": true,
            "video": "",
            "image": "",
            "order": 12,
            "platformJavascript": "polen-irroba-pollinator",
            "domain": "",
            "hasApp": false,
            "linkToPlatform": ""
        },
        {
            "platformId":"d12c9696-252c-41b5-8908-dbe0cc4526c2",
            "storeScaffoldId": "e14870f5-4b5b-4ccd-996e-59a3829e5f7a",
            "logo":"../../../assets/img/plataformas/logo-magento.png",
            "name": "Magento",
            "seoName": "magento",
            "integrada": true,
            "video": "",
            "image": "",
            "order": 13,
            "platformJavascript": "polen-magento-pollinator",
            "domain": "",
            "hasApp": false,
            "linkToPlatform": ""
        },
        {
            "platformId":"f93b9c26-b9b1-4f37-9042-07020a0049a5",
            "storeScaffoldId": "eaa6e67d-9465-49b9-aa62-a45b3f5302c6",
            "logo":"../../../assets/img/plataformas/logo-iluria.png",
            "name": "Iluria",
            "seoName": "Iluria-flower",
            "integrada": true,
            "video": "",
            "image": "",
            "order": 14,
            "platformJavascript": "polen-Iluria-pollinator",
            "domain": "",
            "hasApp": false,
            "linkToPlatform": ""
        },
        {
            "platformId":"324cabba-3d96-42ee-9355-3daaeb09da99",
            "storeScaffoldId": "220108e7-8792-45a9-8347-1f53fe556884",
            "logo":"../../../assets/img/plataformas/logo-wix.png",
            "name": "Wix",
            "seoName": "wix-flower",
            "integrada": true,
            "video": "",
            "image": "",
            "order": 15,
            "platformJavascript": "polen-wix-pollinator",
            "domain": "",
            "hasApp": false,
            "linkToPlatform": ""
        },
        {
            "platformId":"35143a59-019c-4435-8b9e-66ca498b1a96",
            "storeScaffoldId": "afc6e2f6-3dc6-4ceb-b817-8d8a5866990d",
            "logo":"../../../assets/img/plataformas/logo-iset.png",
            "name": "iSET",
            "seoName": "iset",
            "integrada": true,
            "video": "",
            "image": "",
            "order": 16,
            "platformJavascript": "polen-iset-pollinator",
            "domain": "",
            "hasApp": false,
            "linkToPlatform": ""
        },
        {
            "platformId":"5f92d820-2019-40f1-a642-0c3d93f785f6",
            "storeScaffoldId": "44ded178-70d6-4194-8a95-ae3a8b2f02fe",
            "logo":"../../../assets/img/plataformas/logo-menuintegrado.png",
            "name": "Menu Integrado",
            "seoName": "menuintegrado",
            "integrada": true,
            "video": "",
            "image": "",
            "order": 17,
            "platformJavascript": "polen-menuintegrado-pollinator",
            "domain": "",
            "hasApp": false,
            "linkToPlatform": ""
        },
        {
            "platformId":"5bce14d5-15b7-4cb9-aa6e-87f62e055fba",
            "storeScaffoldId": "4d875f96-c052-415e-86ae-f2e01ebf1a06",
            "logo":"../../../assets/img/plataformas/logo-magazord.png",
            "name": "Magazord",
            "seoName": "magazord",
            "integrada": true,
            "video": "",
            "image": "",
            "order": 18,
            "platformJavascript": "polen-magazord-pollinator",
            "domain": "",
            "hasApp": false,
            "linkToPlatform": ""
        },
        {
            "platformId":"8ebb5fa6-ca3d-4cfe-adb7-400efd17198c",
            "storeScaffoldId": "aa81a34a-17e5-496e-9063-6f4332330ec6",
            "logo":"../../../assets/img/plataformas/logo-betalabs.png",
            "name": "Betalabs",
            "seoName": "betalabs",
            "integrada": true,
            "video": "",
            "image": "",
            "order": 19,
            "platformJavascript": "polen-betalabs-pollinator",
            "domain": "",
            "hasApp": false,
            "linkToPlatform": ""
        },
        {
            "platformId":"81632c79-0366-41a3-8ddf-e19e26458895",
            "storeScaffoldId": "0ba7ad4e-d4e9-46be-ade4-c209058fca95",
            "logo":"../../../assets/img/plataformas/logo-yampi.png",
            "name": "Yampi",
            "seoName": "yampi",
            "integrada": true,
            "video": "",
            "image": "",
            "order": 19,
            "platformJavascript": "polen-yampi-pollinator",
            "domain": "",
            "hasApp": false,
            "linkToPlatform": ""
        },
        {
            "platformId":"bf6b9ee1-7783-40c6-866a-bdfdc6484eea",
            "storeScaffoldId": "24b0e940-0357-4242-aa5f-8252211f9fc5",
            "logo":"../../../assets/img/plataformas/logo-convertize.png",
            "name": "Convertize",
            "seoName": "convertize",
            "integrada": true,
            "video": "",
            "image": "",
            "order": 20,
            "platformJavascript": "polen-convertize-pollinator",
            "domain": "",
            "hasApp": false,
            "linkToPlatform": ""
        },
        {
            "platformId": "902a0c85-a774-468b-b604-5f1db14dfc94",
            "storeScaffoldId": "59fd53ae-b5cb-4864-937c-f65875fd66e1",
            "logo":"../../../assets/img/plataformas/logo-vnda.png",
            "name": "Vnda",
            "seoName": "vnda",
            "integrada": true,
            "video": "",
            "image": "",
            "order": 21,
            "platformJavascript": "polen-vnda-pollinator",
            "domain": "",
            "hasApp": false,
            "linkToPlatform": ""
        }
        // {
        //     "platformId": "f1cd536d-4a8a-4704-b5ea-b6ffbc3d3062",
        //     "storeScaffoldId": "87c3a3e2-ea36-47a1-8912-bcb868af4529",
        //     "logo":"../../../assets/img/plataformas/plataforma-propria.png",
        //     "name": "Plataforma Própria",
        //     "seoName": "plataforma-propria",
        //     "integrada": true,
        //     "video": "",
        //     "image": "",
        //     "order": 99,
        //     "platformJavascript": "polen-plataforma-propria-pollinator",
        //     "domain": "",
        //     "hasApp": false,
        //     "linkToPlatform": ""
        // }
    ]
}
